import { Container, Graphics, Sprite, Text, withPixiApp } from '@inlet/react-pixi'
import React, { Component } from "react";
import UIManager from "./UiBuilder";


interface IProps {
    [x: string]: any;

    // loader: {
    //     config: {string:string}
    // }
}

interface IState {

}

class UIContainer extends React.Component<IProps, IState> {


    protected containerObj: any;
    protected Layer: any;
    protected offsetX: any;
    protected offsetY: any;

    constructor(props: IProps) {
        super(props);
        this.containerObj = {};
        this.Layer = {};
        this.offsetX = this.props.offsetX;
        this.offsetY = this.props.offsetY;
    }


    componentDidMount() {
        // this.createContainer();
    }


    createContainer() {
        return (<Container ref={i => this.containerObj = i} x={this.props.x} y={this.props.y}
            visible={this.props.visible || false}
            width={this.props.width} anchor={this.props.anchor}
            height={this.props.height}></Container>);
    }

    componentWillUnmount() {

    }


    // static getDerivedStateForomProps(props: IProps, state: IState): IState {
    //
    //     if (props.disabled) {
    //         return {
    //             ...state,
    //             currentState: props.btnDetails.buttonState['disabled']
    //         }
    //     }
    //     if (props.enable) {
    //         return {
    //             ...state,
    //             currentState: props.btnDetails.buttonState['enable']
    //         }
    //     }
    //     return state;
    // }
    addRef = (name: string, ref: any) => {
        UIManager.ref[name] = ref
    }

    render() {


        if (this.props.child) {
            return <Container {...this.props} ref={i => {
                this.props.addRef(this.props.name, i);
                return this.containerObj = i;
            }}>
                {this.props.child.map((i: any) => <UIManager addRef={this.addRef} key={`UIManager-${Math.random()}`}
                    type={i.type} id={i.id} {...i} ClickHandler={this.props.ClickHandler} mouseOver={this.props.mouseOver} mouseOut={this.props.mouseOut}
                    langObj={this.props.langObj} app={this.props.app} />)}
            </Container>
        } else {
            return <Container ref={i => {
                this.props.addRef(this.props.name, i);
                return this.containerObj = i;
            }} {...this.props} ></Container>
        }

    }

}

//export default withPixiApp(withButtonPanelConfiguration(ButtonStaticImage));
export default UIContainer;